const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Udemy Importer Directive to display a list or table with tracks to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} ManageTracks the resource defined to get and set Tracks data
 */
app.directive('udemyImporter', ['Application', 'ContentIntegrations', '$translate', function (Application, ContentIntegrations, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      onImport: '&'
    },
    template: require('../../templates/directives/udemy-importer.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};

      self.content = {
        oneHalf: [],
        twoHalf: []
      };

      self.comms = {
        page: 1,
        page_size: 15,
        searchTerm: '',
        lastSearched: '',
        endOfLine: false,
        loading: false,
        holdTime: 500,
        throttleHold: null,
        request: function(query) {
          var options = {
            page: self.comms.page,
            page_size: self.comms.page_size
          };

          options = Object.assign(self.searchOptions.currentSettings, options);

          if (self.comms.searchTerm) {
            options.search = self.comms.searchTerm;
            options.is_affiliate_agreed = true;
          }

          return ContentIntegrations.searchContent({name: 'udemy'}, options).$promise;
        },
        load: function(immediate) {
          var time = immediate ? 1 : self.comms.holdTime;
          if (self.comms.throttleHold) {
            window.clearTimeout(self.comms.throttleHold);
          }
          self.comms.loading = true;
          self.comms.throttleHold = setTimeout(function() {
            self.comms.request()
            .then(function(body) {
              if (!body.results || body.count === 0 || body.results.length < self.comms.page_size) {
                self.comms.endOfLine = true;
              }
              self.content.oneHalf = body.results;
              self.content.twoHalf = [];
              self.selection.course = null;
              self.comms.loading = false;
            }).catch(function(error) {
              // Application.messaging.addMessage({})
              self.comms.loading = false;
            });
            self.comms.throttleHold = null;
          }, time);
        },
        searchChange: function() {
          if (self.comms.searchTerm.length === 1) {
            return;
          }
          self.comms.endOfLine = false;
          self.comms.lastSearched = self.comms.searchTerm;
          self.comms.page = 1;
          self.comms.load();
        },
        nextPage: function() {
          if (self.comms.endOfLine) {
            return;
          }
          if (self.comms.searchTerm && self.comms.searchTerm !== self.comms.lastSearched) {
            self.comms.searchTerm = self.comms.lastSearched;
          }
          self.comms.page++;
          self.comms.load(true);
          window.scrollTo(0, 0);
        },
        previousPage: function() {
          if (self.comms.page < 2) {
            return;
          }
          if (self.comms.searchTerm && self.comms.searchTerm !== self.comms.lastSearched) {
            self.comms.searchTerm = self.comms.lastSearched;
          }
          self.comms.page--;
          self.comms.load(true);
          window.scrollTo(0, 0);
        },
      };

      self.searchOptions = {
        currentSettings: {},
        orderingOptions: [],
        showOrdering: false,
        orderingName: null,
        orderingChange: function(item) {
          self.searchOptions.currentSettings.ordering = item.value;
          if (!item.value) {
            delete self.searchOptions.currentSettings.ordering;
          }
          self.searchOptions.orderingName = item.value ? item.name : '';
          self.searchOptions.showOrdering = false;
          self.comms.load();
        },
        ratingOptions: [],
        showRating: false,
        ratingName: null,
        ratingChange: function(item) {
          self.searchOptions.currentSettings.ratings = item.value;
          if (!item.value) {
            delete self.searchOptions.currentSettings.ratings;
          }
          self.searchOptions.ratingName = item.value ? item.name : '';
          self.searchOptions.showRating = false;
          self.comms.load();
        },
        durationOptions: [],
        showDuration: false,
        durationName: null,
        durationChange: function(item) {
          self.searchOptions.currentSettings.duration = item.value;
          if (!item.value) {
            delete self.searchOptions.currentSettings.duration;
          }
          self.searchOptions.durationName = item.value ? item.name : '';
          self.searchOptions.showDuration = false;
          self.comms.load();
        }
      };

      self.selection = {
        course: null,
        loading: false,
        select: function(index, item, half) {
          if (index === 'cancel' || self.selection.course && self.selection.course.id && item.id && item.id === self.selection.course.id) {
            self.content.oneHalf = self.content.oneHalf.concat(self.content.twoHalf);
            self.content.twoHalf = [];
            self.selection.course = null;
            return;
          }
          self.selection.course = item;
          if (!item.id) {
            // Handle error
            return;
          }
          var calculatedIndex = half === 1 ? index : self.content.oneHalf.length + index;
          self.content.oneHalf = self.content.oneHalf.concat(self.content.twoHalf);
          self.content.twoHalf = self.content.oneHalf.splice(calculatedIndex + 1);
          self.selection.loading = true;
          ContentIntegrations.udemyCourse({name: item.id}).$promise
          .then(function(course) {
            self.selection.course = course;
            self.selection.loading = false;
          }).catch(function(error) {
            // handle error
            console.log('error: ', error);
            self.selection.loading = false;
          });
        },
        importCourse: function() {
          if (!self.selection.course || !self.selection.course.id) {
            return;
          }
          // Application.storage.put('course_import', {vendor: 'udemy', course: self.selection.course.id, expire: new Date().setMinutes(new Date().getMinutes() + 1)});
          // Application.navigation.goTo('/edit/imported-content');
          $scope.onImport({item: {vendor: 'udemy', course: self.selection.course.id}});
          Application.scrollTop();
        },
        importDirect: function(id){
          $scope.onImport({item: {vendor: 'udemy', course: id}});
          Application.scrollTop();
        }
      };

      self.initialize = function() {
        self.comms.load(true);
      };

      $translate([
        'edit.importedcontent.relevance',
        'edit.importedcontent.most_viewed',
        'edit.importedcontent.highest_rated',
        'edit.importedcontent.newest',
        'edit.importedcontent.price_low_high',
        'edit.importedcontent.price_high_low',
        'edit.importedcontent.clear',
        'edit.importedcontent.star',
        'edit.importedcontent.short',
        'edit.importedcontent.medium',
        'edit.importedcontent.long',
        'edit.importedcontent.extra_long',
      ]).then(function(translations) {
        self.translations = translations;
        self.searchOptions.orderingOptions = [
          {name: self.translations['edit.importedcontent.relevance'], value: 'relevance'},
          {name: self.translations['edit.importedcontent.most_viewed'], value: 'most-reviewed'},
          {name: self.translations['edit.importedcontent.highest_rated'], value: 'highest-rated'},
          {name: self.translations['edit.importedcontent.newest'], value: 'newest'},
          {name: self.translations['edit.importedcontent.price_low_high'], value: 'price-low-to-high'},
          {name: self.translations['edit.importedcontent.price_high_low'], value: 'price-high-to-low'},
          {name: self.translations['edit.importedcontent.clear'], value: null}
        ];
        self.searchOptions.ratingOptions = [
          {name: '1 ' + self.translations['edit.importedcontent.star'] + ' +', value: '1'},
          {name: '2 ' + self.translations['edit.importedcontent.star'] + ' +', value: '2'},
          {name: '3 ' + self.translations['edit.importedcontent.star'] + ' +', value: '3'},
          {name: '4 ' + self.translations['edit.importedcontent.star'] + ' +', value: '4'},
          {name: '5 ' + self.translations['edit.importedcontent.star'] + ' +', value: '5'},
          {name: self.translations['edit.importedcontent.clear'], value: null}
        ];
        self.searchOptions.durationOptions = [
          {name: self.translations['edit.importedcontent.short'], value: 'short'},
          {name: self.translations['edit.importedcontent.medium'], value: 'medium'},
          {name: self.translations['edit.importedcontent.long'], value: 'long'},
          {name: self.translations['edit.importedcontent.extra_long'], value: 'extraLong'},
          {name: self.translations['edit.importedcontent.clear'], value: null}
        ];
        self.initialize();
      });
    }],
    controllerAs: 'udemy'
  }
}]);